import { Injectable } from "@angular/core";
import { BudgetVsActualConfigHttpService } from "../services/budget-vs-actual-config-http.service";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import * as BudgetVsActualConfigActions from '../actions/budget-vs-actual-config.actions';
import { map, mergeMap} from "rxjs";

@Injectable()
export class BudgetVsActualConfigEffects {

    constructor(
        private readonly actions$: Actions,
        private readonly httpService: BudgetVsActualConfigHttpService
    ) {
        
     }

     bvaConfigLoad$ = createEffect(() => this.actions$.pipe(
        ofType(BudgetVsActualConfigActions.BudgetConfigDataLoad),
        mergeMap(action => this.httpService.getConfiguration(
                    action.widgetConfigId).pipe(
            map(response => BudgetVsActualConfigActions.BudgetConfigDataLoadComplete({
                widgetConfigId: action.widgetConfigId,
                data: response.BudgetVsActualConfig
            }))
            
        ))
    ));
    
}